import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { IdentityService } from 'src/app/core/identity.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FollowUpViewBase } from 'src/app/shared/models/followup-base-view.model';

@UntilDestroy()
@Component({
    selector: 'nova-recruiter-resources-base',
    template: '<div></div>',
    standalone: true,
    styleUrls: []
})
export abstract class RecruiterResourcesBaseComponent implements OnInit, OnDestroy {
    candidateId: number;

    recruiterId: number;

    followup: FollowUpViewBase;

    isDoneLoading = false;

    protected readonly _cleanup$ = new Subject();

    constructor(
        private readonly route: ActivatedRoute,
        private readonly identityService: IdentityService
    ) {}

    ngOnInit(): void {
        this.recruiterId = this.identityService.current.contactId;

        this.route.params.pipe(takeUntil(this._cleanup$), untilDestroyed(this)).subscribe((params) => {
            this.candidateId = params.id;

            this.requestRecruiterFollowupForCandidate();
        });
    }

    public abstract requestRecruiterFollowupForCandidate(): void;

    ngOnDestroy(): void {
        this._cleanup$.next(true);
        this._cleanup$.complete();
    }
}
